module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.project) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projecten")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ProjectEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.name))])], 1)]), _vm._v(" "), _c('h1', [_vm._v("Project: " + _vm._s(_vm.project.name))]), _vm._v(" "), _c('div', [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.name),
      expression: "project.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Projectnaam"
    },
    domProps: {
      "value": (_vm.project.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.info),
      expression: "project.info"
    }],
    staticClass: "uk-input",
    attrs: {
      "placeholder": "Project Info"
    },
    domProps: {
      "value": (_vm.project.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.category),
      expression: "project.category"
    }],
    staticClass: "uk-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', [_vm._v(_vm._s(c))])
  }))]), _vm._v(" "), _c('image-picker', {
    staticClass: "uk-margin",
    on: {
      "choose": _vm.choose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-child-width-1-4@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.project.gallery), function(g, i) {
    return _c('div', [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": g.small || g.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(g.description))])]), _vm._v(" "), _c('span', {
      staticClass: "uk-card-badge uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeImage(i)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Updaten")]) : _vm._e(), (_vm.loading) ? _c('span', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4951f9c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CUSTOM/custom-modules/PROJECTS/ProjectEdit.vue
// module id = 513
// module chunks = 1